"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _common = require("../../common");

var _lib = require("../../lib");

var _Item = _interopRequireDefault(require("./Item"));

require("./styles.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Steps =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Steps, _PureComponent);

  function Steps(_props) {
    var _this;

    _classCallCheck(this, Steps);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Steps).call(this, _props));

    _defineProperty(_assertThisInitialized(_this), "getActive", function (step, totalSteps) {
      var active = _this.state.active;

      if (active) {
        if ((0, _lib.isFunc)(active)) {
          return active(step, totalSteps);
        }

        return active.toString() === step.toString();
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "handleStepsState", function () {
      var _this$props = _this.props,
          steps = _this$props.steps,
          circular = _this$props.circular,
          outline = _this$props.outline,
          children = _this$props.children;
      var nodes = []; // handle step props

      if ((0, _lib.isString)(steps) || (0, _lib.isNumber)(steps)) {
        var _loop = function _loop(step) {
          nodes.push(_react.default.createElement(Steps.Item, {
            key: step,
            wrapperRef: _react.default.createRef(),
            innerRef: _react.default.createRef(),
            circular: circular,
            outline: outline,
            onClick: function onClick(e) {
              return _this.handleOnClick(e, {
                step: step
              });
            },
            active: _this.getActive(step, steps)
          }, step));
        };

        for (var step = 1; step <= steps; step += 1) {
          _loop(step);
        }
      } // handle array objects step props


      if ((0, _lib.arrayHasItems)(steps)) {
        steps.forEach(function (_ref, idx) {
          var content = _ref.content,
              active = _ref.active,
              description = _ref.description;
          var step = idx + 1;
          nodes.push(_react.default.createElement(Steps.Item, {
            key: step,
            wrapperRef: _react.default.createRef(),
            innerRef: _react.default.createRef(),
            circular: circular,
            outline: outline,
            onClick: function onClick(e) {
              return _this.handleOnClick(e, {
                step: step
              });
            },
            active: active || _this.getActive(step, steps.length),
            description: description
          }, content || step));
        });
      } // handle children props


      if (children && !steps) {
        var totalChilds = _react.Children.count(children);

        _react.Children.forEach(children, function (child, idx) {
          if (Steps.isStepsItem(child)) {
            var step = idx + 1;
            var childProps = {
              key: step,
              wrapperRef: _react.default.createRef(),
              innerRef: _react.default.createRef(),
              circular: circular,
              outline: outline,
              onClick: child.props.onClick || function (e) {
                return _this.handleOnClick(e, {
                  step: step
                });
              },
              active: _this.getActive(step, totalChilds) || child.props.active
            };

            var node = _react.default.cloneElement(child, childProps);

            nodes.push(node);
          }
        });
      }

      _this.setState({
        steps: nodes
      }, function () {
        var connected = _this.props.connected;
        if (connected) _this.createGap();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleResize", function () {
      var steps = _this.state.steps;
      steps.forEach(function (_ref2, idx, arr) {
        var props = _ref2.props;

        // ignore last one
        if (idx < arr.length - 1) {
          var parentNode = props.wrapperRef.current;

          if (parentNode) {
            // remove the line node ( second node )
            while (parentNode.childNodes[1]) {
              parentNode.removeChild(parentNode.childNodes[1]);
            }
          }
        }
      }); // create another line

      _this.createGap();
    });

    _defineProperty(_assertThisInitialized(_this), "createGap", function () {
      var steps = _this.state.steps;

      if (steps.length > 1) {
        var horizontal = _this.props.horizontal; // calculate gap distance

        steps.forEach(function (_ref3, idx, arr) {
          var props = _ref3.props;

          // ignore last one
          if (idx < arr.length - 1) {
            var currentInner;
            var currentInnerLength;
            var currentWrapper;
            var nextInner;
            var nextWrapper;
            var nextStepProps = steps[idx + 1].props;
            var currentInnerBox = props.innerRef.current.getBoundingClientRect();
            var currentWrapperBox = props.wrapperRef.current.getBoundingClientRect();
            var nextWrapperBox = nextStepProps.wrapperRef.current.getBoundingClientRect();
            currentInner = props.innerRef.current.offsetTop;
            currentInnerLength = currentInnerBox.height;
            currentWrapper = currentWrapperBox.top;
            nextInner = nextStepProps.innerRef.current.offsetTop;
            nextWrapper = nextWrapperBox.top;

            if (horizontal) {
              currentInner = props.innerRef.current.offsetLeft;
              currentInnerLength = currentInnerBox.width;
              currentWrapper = currentWrapperBox.left;
              nextInner = nextStepProps.innerRef.current.offsetLeft;
              nextWrapper = nextWrapperBox.left;
            }

            var currentActual = currentWrapper + currentInner + currentInnerLength;
            var nextActual = nextWrapper + nextInner;
            var gap = nextActual - currentActual;
            var parentNode = props.wrapperRef.current;

            if (parentNode) {
              var gapEL = document.createElement('div');
              gapEL.classList.add('MHub-Steps-Gap');

              if (horizontal) {
                gapEL.classList.add('horizontal');
              } // gap style


              var style = "".concat(horizontal ? 'width' : 'height', ": ").concat(gap, "px;");
              gapEL.setAttribute('style', style);
              parentNode.appendChild(gapEL);
            }
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "classNames", function () {
      var names = [Steps.className];
      var propNames = ['circular', 'outline', 'connected', 'horizontal'];
      (0, _lib.addClassByPropName)(names, _this.props, propNames);
      (0, _lib.addClassByPropValue)(names, _this.props, ['color']);
      return names.join(' ');
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnClick", function (e, _ref4) {
      var step = _ref4.step;
      (0, _lib.callEventMethods)(e, 'persist');
      var onClick = _this.props.onClick;

      if (onClick) {
        onClick(e, {
          step: step
        });
      }
    });

    var _active = _props.active;
    _this.state = {
      prevProps: {
        active: _active
      },
      active: _active,
      steps: []
    };
    return _this;
  }

  _createClass(Steps, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var connected = this.props.connected;
      this.handleStepsState(); // only add resize event listener for connected steps

      if (connected) window.addEventListener('resize', this.handleResize);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var connected = this.props.connected;

      if (connected !== prevProps.connected) {
        if (connected) {
          this.handleResize();
          window.addEventListener('resize', this.handleResize);
        } else {
          window.removeEventListener('resize', this.handleResize);
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var connected = this.props.connected; // remove event listener

      if (connected) window.removeEventListener('resize', this.handleResize);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          as = _this$props2.as,
          active = _this$props2.active,
          steps = _this$props2.steps,
          className = _this$props2.className,
          children = _this$props2.children,
          color = _this$props2.color,
          connected = _this$props2.connected,
          circular = _this$props2.circular,
          outline = _this$props2.outline,
          horizontal = _this$props2.horizontal,
          onClick = _this$props2.onClick,
          rest = _objectWithoutProperties(_this$props2, ["as", "active", "steps", "className", "children", "color", "connected", "circular", "outline", "horizontal", "onClick"]);

      var Wrapper = (0, _lib.getElementType)(this, this.props);
      var classNames = this.classNames();
      return _react.default.createElement(Wrapper, _extends({}, rest, {
        className: classNames
      }), this.state.steps);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevProps = state.prevProps; // Compare the incoming prop to previous prop

      var active = props.active;
      return {
        prevProps: {
          active: active
        },
        active: prevProps.active !== active ? active : state.active
      };
    }
  }]);

  return Steps;
}(_react.PureComponent);

exports.default = Steps;

_defineProperty(Steps, "className", 'MHub-Steps');

_defineProperty(Steps, "Item", _Item.default);

_defineProperty(Steps, "isStepsItem", function (child) {
  return (0, _lib.isFunc)(child.type) && child.type.name === _Item.default.name;
});

_defineProperty(Steps, "displayName", 'Steps');

_defineProperty(Steps, "propTypes", {
  as: _common.customPropTypes.as,
  children: _propTypes.default.node,
  color: _propTypes.default.oneOf(['blue', 'red', 'orange', 'yellow', 'green']),
  steps: _propTypes.default.oneOfType([_common.customPropTypes.stringOrNumber, _propTypes.default.arrayOf(_propTypes.default.shape({
    content: _common.customPropTypes.stringOrNumber,
    active: _propTypes.default.bool,
    description: _propTypes.default.node
  }))]),
  className: _propTypes.default.string,
  circular: _propTypes.default.bool,
  outline: _propTypes.default.bool,
  connected: _propTypes.default.bool,
  horizontal: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  active: _propTypes.default.oneOfType([_common.customPropTypes.stringOrNumber, _propTypes.default.func])
});

_defineProperty(Steps, "defaultProps", {
  as: 'div',
  color: null,
  children: null,
  steps: null,
  className: null,
  circular: false,
  outline: false,
  connected: true,
  horizontal: false,
  onClick: null,
  active: null
});